import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerIdentifiers {
  accountId: string;
  customerId: string;
}

interface PhoneInfo {
  type: string;
  value: string;
  verificationStatus: string;
}

interface SendVerificationRequest {
  customerIdentifiers: CustomerIdentifiers;
  phoneInfo: PhoneInfo;
  programName: string;
}

interface SendVerificationResponse {
  customerIdentifiers: CustomerIdentifiers;
  programName: string;
  phoneInfo: PhoneInfo;
}

export interface SmsVerificationState {
  loading: boolean;
  success: boolean;
  error: string | null;
  verificationResponse: SendVerificationResponse | null;
}

const initialState: SmsVerificationState = {
  loading: false,
  success: false,
  error: null,
  verificationResponse: null,
};

const smsVerificationSlice = createSlice({
  name: 'smsVerification',
  initialState,
  reducers: {
    // Send verification text
    sendVerificationTextRequest(
      state,
      action: PayloadAction<{
        customerIdentifiers: CustomerIdentifiers;
        phoneInfo: PhoneInfo;
        programName: string;
      }>
    ) {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    sendVerificationTextSuccess(
      state,
      action: PayloadAction<SendVerificationResponse>
    ) {
      state.loading = false;
      state.success = true;
      state.verificationResponse = action.payload;
      state.error = null;
    },
    sendVerificationTextFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    // Reset state
    resetSmsVerificationState(state) {
      return initialState;
    },
  },
});

export const {
  sendVerificationTextRequest,
  sendVerificationTextSuccess,
  sendVerificationTextFailure,
  resetSmsVerificationState,
} = smsVerificationSlice.actions;

export default smsVerificationSlice.reducer;
